import React from "react";
import Tools from "../../components/tools/Tools";
import { Box } from "@chakra-ui/react";

const ToolsPage = (): JSX.Element => {
  return (
    <Box>
      <Tools />
    </Box>
  );
};

export default ToolsPage;
